import axios from "axios";
import { io } from "socket.io-client";
import { base_url } from "../../utils/baseUrl";

let socket;

const getOnlineVisitors = async () => {
  const response = await axios.get(`${base_url}online`);
  return response.data;
};

const initSocket = (callback) => {
  if (!socket) {
    socket = io(base_url, { transports: ["websocket"] });

    socket.on("connect", () => {
      console.log("✅ Connected to Socket.IO server:", socket.id);
    });

    socket.on("visitor-update", (payload) => {
      console.log("⚡ Live visitor update:", payload);

      if (callback) callback(payload); // send entire payload (type + data)
    });

    socket.on("disconnect", () => {
      console.log("❌ Disconnected from Socket.IO server");
    });
  }

  return socket;
};

const sendGPS = (coords) => {
  if (!socket) return;

  console.log("📡 Sending GPS:", coords);
  socket.emit("gps-location", coords);
};

const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("❌ Socket disconnected");
  }
};

const trackService = {
  getOnlineVisitors,
  initSocket,
  disconnectSocket,
  sendGPS, // ✅ needed for frontend to send real GPS
};

export default trackService;
